export const fieldMapping: Record<string, string> = {
    exporter: 'DC Exporter Id',
    cooNumber: 'DC COO Number',
    exporterType: 'DC Exporter Type',
    consignee: 'DC Consignee Id',
    consigneeType: 'DC Consignee Type',
    invoiceNo: 'DC Invoice Number',
    invoiceDate: 'DC Invoice Date',
    invCurrency: 'Currency',
    invAmount: 'DC Invoice Amount',
    directShip: 'DC Direct Shipment',
    shippingFrom: 'DC Shipping From',
    transportMode: 'DC Transport By',
    exitPoint: 'DC Exit Point',
    countryDest: 'DC Final Destination',
    stampPosition: 'Stamp Position',
    portOfDischarge: 'DC Port of Discharge',
    expectedDepartureDate: 'DC Expected Departure Date',
    requiredCOO: 'DC Print COO Product Flg',
    additionalDetails: 'DC Additional Detail',
    GSPAuthorizedPerson: 'DC GSP Authorized Person',
    paymentMethod: 'DC Payment Method',
    attestationRequired: 'DC Require Attestation Flag',
    signatory: 'DC Print Name English'
};
